import React, { useEffect, useState } from "react";
import { authApiService } from "../../../api/api";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { ReactComponent as EditModalIcon } from "../../../assets/icons/modal/editusermodal.svg";
import { ICategory } from "../../../types/category.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditCategoryForm from "../forms/EditCategoryForm/EditCategoryForm";
import ViewCategoryForm from "../forms/EditCategoryForm/ViewCategoryForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  category: ICategory;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
}

const EditCategoryModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteCategory(props.category.id);
      console.log(response);

      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення категорії"
              subTitle="Ви дійсно хочете видалити цю категорію? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагувати категорію"
              subTitle='Редагуйте інформацію про категорію. Внесіть необхідні зміни та натисніть "Зберегти" для оновлення даних.'
            >
              <EditModalIcon />
            </ModalTitle>
            <EditCategoryForm
              category={props.category}
              onClose={() => setIsDelete(true)}
              onApply={onPressApply}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.upSide}>
                <img
                  src={props.category.imageUrl}
                  alt="Avatar"
                  className={styles.avatar}
                />
                <button className={styles.upSideButton} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
              <div className={styles.nameContainer}>
                <span className={styles.name}>{props.category.name}</span>
              </div>
            </div>
            <ViewCategoryForm
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              category={props.category}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditCategoryModal;
